import styled from "styled-components";

export const Container = styled.main`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgb(0,0,0, 0.2);
    z-index: 1000;

    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width) {
        max-height: 80%;
    }
`;

export const Content = styled.div`
    background-color: ${(props) => props.theme.colors.white};
    width: 600px;
    padding: 30px;
    border-radius: 4px;

    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const Header = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    svg{
        color: ${(props) => props.theme.colors.gray.gray_600};
    }
`;

export const infor = styled.div``;

export const Title = styled.p`
    font-size: 24px;
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-weight: 500;
`;

export const SubTitle = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_500};
    font-size: 14px;
`;

export const ButtonClose = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
`;

export const Footer = styled.footer`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

export const TitleList = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-weight: 500;
    font-size: 14px;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;

    thead {
        background-color: ${(props) => props.theme.colors.gray.gray_50};
        position: sticky;
        top: 0;
        z-index: 1;
    }

    th:nth-child(1),
    td:nth-child(1),
    th:last-child,
    td:last-child {
        width: 85px;
    }

    tbody {
        display: block;
        max-height: 200px;
        overflow-y: auto;
        width: 100%;
    }

    tbody::-webkit-scrollbar { 
        display: none;
    }

    tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    td,
    th {
        text-align: center;
        padding: 10px 0;
    }

    td > div {
        display: flex;
        justify-content: space-around;
    }
    
    & svg {
        font-size: 18px;
        
    }
    
    & button {
        text-align: center;
        display: flex;
        background-color: ${(props) => props.theme.colors.white};
        border-radius: 30px;
        padding: 8px;
        box-shadow: 0px 1px 4px 0px ${(props) => props.theme.colors.gray.gray_100};
        
        &:hover {
            background-color: ${(props) => props.theme.colors.gray.gray_100};
        }
    }

    @media (max-width: 900px) {
        th:nth-child(5), 
        td:nth-child(5) {
            display: none;
        }

        th:nth-child(1),
        td:nth-child(1),
        th:last-child,
        td:last-child {
            width: 50px;
        }

        tbody {
            max-height: 450px;
        }
    }
`;